import { AdminNotificationsProvider } from "../components/admin/notifications/AdminNotificationsContext";
import { SessionSipActivityProvider } from "../components/admin/sessionActivity/SessionSipActivityContext";
import { CitiesProvider } from "./CitiesContext";

export default function AppProviders({ children }) {
  return (
    <CitiesProvider><AdminNotificationsProvider>
      <SessionSipActivityProvider>{children}</SessionSipActivityProvider>
    </AdminNotificationsProvider></CitiesProvider>
  );
}
